import { render, staticRenderFns } from "./navgate.vue?vue&type=template&id=28551209"
import script from "./navgate.vue?vue&type=script&lang=js"
export * from "./navgate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports